import { DetailsList, FontSizes, FontWeights, PrimaryButton, SelectionMode, Stack } from "@fluentui/react";
import * as React from "react";

function AgreementFiles({ items }) {

    const columns = [
        {
            key: 'name',
            name: 'Nazwa Dokumentu',
            ariaLabel: 'Nazwa Dokumentu',
            fieldName: 'name',
            minWidth: 300,
            isRowHeader: true,
            isResizable: false,
            onRender: (item) => (<a href={`/api/public/uploaded/${item.filename}`} target={'_blank'}><PrimaryButton text={item.name} /></a>)
        },
        {
            key: 'group',
            name: 'Grupa',
            ariaLabel: 'Grupa',
            fieldName: 'group',
            minWidth: 200,
            isResizable: true,
            onRender: (item) => item.group === 'null' ? '' : item.group
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: true,
        },
        {
            key: 'user',
            name: 'Użytkownik',
            ariaLabel: 'Użytkownik',
            fieldName: 'user',
            minWidth: 120,
            isResizable: true
        }
    ];

    return <Stack.Item grow={true}>
        <h4 style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light }}>Pliki</h4>
        <DetailsList items={items} columns={columns} selectionMode={SelectionMode.none} />
    </Stack.Item>;
}

export default AgreementFiles;